import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import SidebarAtendimento from "../../../components/SidebarAtendimento";
import { toast } from "react-toastify";
import useFormat from "../../../hooks/utils/useFormat";
import AttendanceTable from "../../../components/AttendanceTable";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";

export default function TraineeArea() {
  const { formatQuery } = useFormat();
  const { me } = useWrapper();

  const [attendances, setattendances] = useState();
  const [filter, setfilter] = useState({});
  const [isLoadingAttendances, setisLoadingAttendances] = useState(false);
  const [query, setquery] = useState();
  const applyFilter = async __filter => {
    try {
      setisLoadingAttendances(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter({
          ...__filter,
          page: 1,
        });
      }
      const _query = formatQuery(_filter);
      setquery(_query);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar pagamentos.");
    } finally {
      setisLoadingAttendances(false);
    }
  };

  useEffect(() => {
    applyFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally runs once on mount with the initial filter; applyFilter/filter are recreated every render and re-including them would refire this on every filter change (already handled directly via SidebarAtendimento/AttendanceTable calling applyFilter).
  }, []);

  return (
    <Main className={style.mainUser}>
      <Content noBG="true">
        <Row className="-invert-childs-lg">
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <h2 className="mini-title">Atendimentos:</h2>
              <p className="small-label mb-3">Acompanhe e gerencie os atendimentos registrados.</p>
              {!isLoadingAttendances ? (
                <>
                  <AttendanceTable
                    query={query}
                    attendances={attendances}
                    setattendances={setattendances}
                    applyFilter={applyFilter}
                    filter={filter}
                    url_type="trainee_area"
                    trainee_id={me?.id}
                  />
                </>
              ) : (
                <Loading />
              )}
            </SubContent>
          </Col>
          <Col md={12} lg={3}>
            <SubContent className="p-0">
              <SidebarAtendimento count={attendances?.filter_count} setFilter={applyFilter} filter={filter} />
            </SubContent>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
